import LocalStorageController from 'core-components/classes/services/LocalStorageController'
import settings from 'src/core/config/hostConfig'
import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { getAppOwnerId } from 'src/core/classes/helpers/getAppId'

export const isSimulation = () => {
  if (typeof sessionStorage === 'undefined') {
    return false
  }
  return !!sessionStorage.getItem('simulation')
}

export const getRealUser = () => {
  if (typeof sessionStorage === 'undefined') {
    return ''
  }
  return sessionStorage.getItem('realUser') || ''
}

export const setTokens = (ownerId: string, token: string, refreshToken: string) => {
  set(`_hp_mbe_${ownerId}_access_token`, token)
  set(`_hp_mbe_${ownerId}_refresh_token`, refreshToken)
}

export const setIdentityTokens = (token: string, refreshToken: string) => {
  const id = getAppOwnerId()
  set(`_hp_mbe_${id}_access_token_identity`, token)
  set(`_hp_mbe_${id}_refresh_token_identity`, refreshToken)
}

export const getIdentityTokens = () => {
  const id = getAppOwnerId()
  return [get(`_hp_mbe_${id}_access_token_identity`), get(`_hp_mbe_${id}_refresh_token_identity`)]
}

export const clearTokens = (ownerId?: string) => {
  const id = ownerId || getAppOwnerId()
  remove(`_hp_mbe_${id}_access_token`)
  remove(`_hp_mbe_${id}_refresh_token`)
}

export const getTokens = (ownerId?: string) => {
  const id = ownerId || getAppOwnerId()
  return [get(`_hp_mbe_${id}_access_token`), get(`_hp_mbe_${id}_refresh_token`)]
}

// Legacy-first token selection: identity tokens only when the single-identity-service
// stack signals it (settings.notExchangeToken); otherwise the legacy tokens, unchanged.
export const getActiveTokens = () => (settings.notExchangeToken ? getIdentityTokens() : getTokens())

export const setClientSecret = (ownerId: string, clientId: string, secretId: string) => {
  set(`_hp_mbe_${ownerId}_client_id`, clientId)
  set(`_hp_mbe_${ownerId}_secret_id`, secretId)
}

export const getClientSecret = (ownerId?: string) => {
  const id = ownerId || getAppOwnerId()
  return [get(`_hp_mbe_${id}_client_id`), get(`_hp_mbe_${id}_secret_id`)]
}

export const clearClientSecret = (ownerId?: string) => {
  const id = ownerId || getAppOwnerId()
  remove(`_hp_mbe_${id}_client_id`)
  remove(`_hp_mbe_${id}_secret_id`)
}

// Removes every localStorage key except '__'-prefixed ones before a new login. Apps rely on
// that prefix to keep their own keys across a login (sb-hpscoutso widgetTour README).
export const clearStorageBeforeLogin = () => {
  for (const key in localStorage) {
    if (!key.startsWith('__')) {
      localStorage.removeItem(key)
    }
  }
}

export const set = (key: string, value: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return LocalStorageController.setItem(key, value)
  } else {
    return sessionStorage.setItem(key, value)
  }
}

export const clear = () => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return LocalStorageController.clear()
  } else {
    sessionStorage.clear()
  }
}

export const clearAccountData = () => {
  remove(StorageKeys.user)
}

export const get = (key: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return LocalStorageController.getItem(key)
  }
  return sessionStorage.getItem(key)
}

const remove = (key: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return LocalStorageController.removeItem(key)
  } else {
    sessionStorage.removeItem(key)
  }
}
